<template>
  <v-bottom-sheet max-width="500" v-model="rowDailog" persistent inset v-if="selectedRow">
    <v-card tile class="touch-view-container rounded-t-xl">
      <v-card-title primary-title>
        <span v-if="employeeAccess && employeeAccess.report.showHours">{{ secondsToHms(selectedRow.totalInSeconds) }}</span>
        <span v-else>Detail</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- <v-card class="pa-1 px-2" flat tile color="deep-orange lighten-4">
        <v-row>
          <v-col class="font-weight-bold">In</v-col>
          <v-col class="font-weight-bold">Out</v-col>
          <v-col></v-col>
        </v-row>
      </v-card> -->
      <div class="touch-view-container-detail pa-2">
        <template v-for="(item, index) in selectedRow.row">
          <div :key="index">
            <v-alert
              class="rounded-lg"
              dense
              border="left"
              :type="item.clockOutTime ? 'success' : 'error'"
              :color="item.clockOutTime ? 'indigo lighten-4' : 'red lighten-4'"
            >
              <v-row align="center">
                <v-col cols="7" class="font-weight-bold">
                  <div v-if="employeeAccess && employeeAccess.report.showHours">
                    <span v-if="item.clockOutTime">{{
                      secondsToHms(item.shiftDuration.totalInSeconds)
                    }}</span>
                    <span v-else>Still Clock In</span>
                  </div>
                </v-col>
                <v-col class="text-right">
                  <Edit v-if="employeeAccess && employeeAccess.timeClock.edit" @submit="dataSave" @error="dataError" :editRow="item" />
                  <v-btn v-if="employeeAccess && employeeAccess.timeClock.delete"
                    text
                    dark
                    icon
                    color="primary"
                    @click.stop.prevent="deleteTime(item)"
                  >
                    <v-icon color="white">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-row no-gutters class="my-2">
                <v-col align="center">
                  <v-card
                    dark
                    color="green"
                    width="100"
                    class="rounded-lg flex"
                    @click.stop.prevent="openImage('in', item)"
                  >
                    <v-card-text
                      class="white--text font-weight-bold text-h6 px-2 py-0"
                    >
                      IN
                    </v-card-text>
                    <v-avatar tile size="100" class="rounded-lg">
                      <v-img
                        aspect-ratio="1"
                        height="100"
                        width="100"
                        v-if="item.clockInUrl"
                        :src="item.clockInUrl"
                        :lazy-src="item.clockInUrl"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-2"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                        v-else
                        aspect-ratio="1"
                        height="100"
                        width="100"
                        src="@/assets/images/user.jpeg"
                      ></v-img>
                    </v-avatar>
                  </v-card>

                  <v-flex class="subtitle-2 mt-1">{{
                    item.clockInTime | moment("M/D/YY h:mm A")
                  }}</v-flex>
                </v-col>

                <v-col align="center">
                  <v-card
                    dark
                    color="red"
                    width="100"
                    class="rounded-lg flex"
                    @click.stop.prevent="openImage('out', item)"
                  >
                    <v-card-text
                      class="white--text font-weight-bold text-h6 px-2 py-0"
                    >
                      OUT
                    </v-card-text>
                    <v-avatar tile size="100" class="rounded-lg">
                      <v-img
                        aspect-ratio="1"
                        height="100"
                        width="100"
                        v-if="item.clockOutUrl"
                        :src="item.clockOutUrl"
                        :lazy-src="item.clockOutUrl"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-2"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                        v-else
                        aspect-ratio="1"
                        height="100"
                        width="100"
                        src="@/assets/images/user.jpeg"
                      ></v-img>
                    </v-avatar>
                  </v-card>

                  <v-flex v-if="item.clockOutTime" class="subtitle-2 mt-1">{{
                    item.clockOutTime | moment("M/D/YY h:mm A")
                  }}</v-flex>
                  <v-flex v-else class="subtitle-2 mt-1">
                    <v-chip color="red" small>Working</v-chip>
                  </v-flex>
                </v-col>
              </v-row>
            </v-alert>
          </div>
        </template>
      </div>
    </v-card>
    <v-dialog v-model="imageView" v-if="selectedImage" width="500" class="pa-5">
      <v-card class="rounded-xl">
        <v-card-title primary-title>
          <span v-if="selectedStatus === 'in'">Clock In</span>
          <span v-else>Clock Out</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="imageView = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-5">
          <div v-if="selectedStatus === 'in'" class="text-center">
            <strong>{{ selectedImage.clockInTime | moment("LL LT") }}</strong>
          </div>
          <div v-else class="text-center">
            <strong>{{ selectedImage.clockInTime | moment("LL LT") }}</strong>
          </div>
        </v-card-text>
        <v-card-text>
          <v-img
            v-if="selectedStatus === 'in'"
            :src="selectedImage.clockInUrl"
            :lazy-src="selectedImage.clockInUrl"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>

          <v-img
            v-else
            :src="selectedImage.clockOutUrl"
            :lazy-src="selectedImage.clockOutUrl"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-bottom-sheet>
</template>

<script>
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import Edit from "@/modules/Reports/components/Edit.vue";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import timeClockService from "@/modules/TimeClock/service";
import { mapGetters } from "vuex";

export default {
  name: "day-detail",
  props: ["selectedRow", "dialog", "workingHours"],
  data() {
    return {
      selectedImage: null,
      selectedStatus: null,
      imageView: false,
      rowDailog: false,
    };
  },
  components: {
    SwipeOut,
    SwipeList,
    Edit,
  },
  watch: {
    dialog(val) {
      this.rowDailog = val;
      console.log("selectedRow", this.selectedRow);
    },
  },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
  },
  methods: {
    openImage(status, obj) {
      this.selectedImage = obj;
      this.selectedStatus = status;
      if (status === "in" && obj.clockInUrl) {
        this.imageView = true;
      }
      if (status === "out" && obj.clockOutUrl) {
        this.imageView = true;
      }
    },

    deleteTime(row) {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            timeClockService.delete(row.id).then((response) => {
              if (response.data) {
                this.$toast.success("Entry was deleted", { timeout: 2000 });
                // this.$swal.fire("Deleted!", "Entry was deleted.", "success");
                this.$emit("submit");
              }
            });
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });

          console.log(error);
        });
    },
    dataError(e) {
      console.log("errdataErrordataErroror", e);
      this.$toast.error("Can't save entry, check date and time", {
        timeout: 2000,
      });
      // this.snackbar.text = "Can't save entry, check date and time";
      // this.snackbar.status = true;
      // this.snackbar.color = "error";
    },
    close() {
      this.$emit("close");
    },
    dataSave() {
      // this.snackbar.text = "Time entry saved";
      // this.snackbar.status = true;
      // this.snackbar.color = "black";
      this.$toast.success("Time entry saved", { timeout: 2000 });
      this.$emit("submit");
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      // console.log('AndDown', this.$vuetify.breakpoint.xsOnly)

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

      if (this.$vuetify.breakpoint.xsOnly) {
        hDisplay = h > 0 ? h + " h, " : "";
        mDisplay = m > 0 ? m + " m, " : "";
        sDisplay = s > 0 ? s + " s " : "";
      }

      return hDisplay + mDisplay + sDisplay;
    },
  },
};
</script>

<style scoped >
.touch-view-container {
  height: calc(100vh - 200px);
  width: 100%;
}
.touch-view-container-detail {
  height: calc(100vh - 300px);
  width: 100%;
  overflow: auto;
}
</style>